import { MouseEvent, useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuItemsTypes } from '../../apps/behaviour/behaviour';
import SvgComponent from '../svg/SvgComponent';
import { logout } from '../../apps/auth/query';
import { AlertState } from '../../apps/state/AlertState';
import { MenuState } from '../../apps/state/MenuState';

const SideMenuComponent = ({
  location,
  menuItems,
}: {
  location: any;
  menuItems: MenuItemsTypes[];
}) => {
  const [loading, setLoading] = useState(false);
  const [logo, setLogo] = useState<any>();
  const [loadingMenu, setLoadingMenu] = useState<string>('');
  const { clearAlertState } = useContext(AlertState);
  const { menu } = useContext(MenuState);
  const [subMenu, setSubMenu] = useState<string>('');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setSubMenu(findMenuTag()?.tag || '');
    setLoading(false);
    setMenuOpen(false)
    // eslint-disable-next-line
  }, [location.pathname, menu]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const access = localStorage.getItem('accessToken');

    if (access !== null) {
      const accessTokenData = JSON.parse(access);
      const logo = `https://hg3.justwithu.com/${accessTokenData.setting.logo}`;
      setLogo(logo);
    }
    // eslint-disable-next-line
  }, [setLogo]);

  function findMenuTag(items = menuItems) {
    const foundItem = items.find((item) => {
      if (item.tag === menu) {
        return true;
      }
      if (item.children) {
        return item.children.some((child) => child.tag === menu);
      }
      return false;
    });

    return foundItem;
  }

  // function hasMuneTag(items: any[]): boolean | string {
  //   for (const item of items) {
  //     if (item.tag === menu) {
  //       return true;
  //     }
  //     if (item.children && hasMuneTag(item.children)) {
  //       return true;
  //     }
  //   }
  //   return false;
  // }

  const toggleSubmenu = (tag: string) => {
    setSubMenu(tag);
  };

  const logoutEventHandler = async (event: MouseEvent) => {
    event.preventDefault();
    await logout();
  };

  const clickEventHandler = (id: string) => {
    clearAlertState();
    setLoading(true);
    setLoadingMenu(id);
  };

  return (
    <aside className="show-box relative col-span-5 mlg:col-span-1 h-fit mlg:h-full bg-white px-1 lg:px-5 py-2 mlg:py-7 border border-content-border rounded-lg text-lg">
      <div className="flex items-center">
        <button
          onClick={toggleMenu}
          className="block mlg:hidden px-4 py-3 text-sm bg-white rounded-lg focus:outline-none focus:border-gray-500 focus:text-gray-500"
        >
          <img src="/images/icons/bars.svg" alt="" />
        </button>
        <a  href="https://escapemag.ir" className="logo flex items-center gap-2 mx-auto mlg:mb-7">
         
          <img
            className="w-9 show-box"
            src={logo ?? ''}
            alt="ESCAPE MAG"
            loading="lazy"
          />
          <h1 className="text-lg font-semibold">ESCAPE MAG</h1>
         
        </a>
      </div>
      <div
        className={`${
          menuOpen ? 'block' : 'hidden mlg:block'
        } transition-all duration-300`}
      >
        <ul className="text-base sidebar">
          {menuItems &&
            menuItems.map((menuItem) => (
              <li
                key={menuItem.id}
                id={menuItem.id}
                className="[&:not(:last-child)]:border-dotted [&:not(:last-child)]:border-b-2 [&:not(:last-child)]:border-dotted-borde"
              >
                {menuItem.hasOwnProperty('children') === false || undefined ? (
                  <Link
                    className={`block text-gray-iron py-2 px-3 mb-1 rounded-md transition-all duration-100 hover:bg-orange hover:text-white ${
                      menu === menuItem.tag
                        ? 'disabled-link bg-orange text-white menu-active'
                        : ''
                    }  ${
                      menu === menuItem.tag
                        ? 'bg-orange text-white menu-active'
                        : ''
                    }`}
                    to={menuItem.url ? menuItem.url : ''}
                    onClick={() => {
                      clickEventHandler(menuItem.id);
                    }}
                  >
                    <SvgComponent svgJson={menuItem.icon} />
                    {menuItem.label}
                    {loading && loadingMenu === menuItem.id ? (
                      <svg
                        className="animate-spin mr-1 inline-block h-3 w-3 text-black"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        ></path>
                      </svg>
                    ) : null}
                  </Link>
                ) : (
                  <>
                    <button
                      className="text-right w-full block text-gray-iron py-2 px-3 mb-1 rounded-md transition-all duration-100 hover:bg-orange hover:text-white"
                      onClick={() => {
                        if (menuItem.tag === subMenu) {
                          toggleSubmenu('');
                        } else {
                          toggleSubmenu(menuItem.tag);
                        }
                      }}
                    >
                      <SvgComponent svgJson={menuItem.icon} />
                      {menuItem.label}
                    </button>

                    <ul
                      className={`sub-menu ${
                        subMenu === menuItem.tag
                          ? 'block visible-element'
                          : 'hidden hidden-element'
                      } transition-all duration-300`}
                    >
                      {menuItem.children &&
                        menuItem.children.map((subItem) => (
                          <li
                            className="py-3 px-5"
                            key={subItem.id}
                            id={subItem.id}
                          >
                            <Link
                              className={`block hover:text-orange ${
                                menu === subItem.tag
                                  ? 'disabled-link sub-active text-orange'
                                  : ''
                              } ${
                                menu === subItem.tag
                                  ? 'sub-active text-orange'
                                  : ''
                              }`}
                              to={subItem.url ? subItem.url : ''}
                              onClick={() => {
                                clickEventHandler(subItem.id);
                              }}
                            >
                              {subItem.label}
                              {loading && subItem.id === loadingMenu && (
                                <svg
                                  className="animate-spin mr-1 inline-block h-3 w-3 text-black"
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                >
                                  <circle
                                    className="opacity-25"
                                    cx="12"
                                    cy="12"
                                    r="10"
                                    stroke="currentColor"
                                    strokeWidth="4"
                                  ></circle>
                                  <path
                                    className="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  ></path>
                                </svg>
                              )}
                            </Link>
                          </li>
                        ))}
                    </ul>
                  </>
                )}
              </li>
            ))}
          <li className="[&:not(:last-child)]:border-dotted [&:not(:last-child)]:border-b-2 [&:not(:last-child)]:border-dotted-borde">
            <button
              className="w-full text-right block text-gray-iron py-2 px-3 mb-1 rounded-md transition-all duration-100 hover:bg-orange hover:text-white"
              onClick={(event) => logoutEventHandler(event)}
            >
              <svg
                width="21"
                height="21"
                viewBox="0 0 21 21"
                className="inline-block ml-3"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.13672 10.0264H15.0117"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  stroke="black"
                  className="change-stroke"
                ></path>
                <path
                  d="M9.38672 4.40137L15.0117 10.0264L9.38672 15.6514"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  stroke="black"
                  className="change-stroke"
                ></path>
                <path
                  d="M17.5117 3.15137V16.9014"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  stroke="black"
                  className="change-stroke"
                ></path>
              </svg>
              خروج
            </button>
          </li>
        </ul>
      </div>
      <div
        className={`absolute top-0 right-0 left-0 bottom-0 z-50 ${
          loading ? 'bg-white opacity-0' : 'hidden'
        }`}
      ></div>
    </aside>
  );
};

export default SideMenuComponent;
